export default {
  cards: {
    info: {
      totalResponden: {
        queryName: "total_survey_sipenda",
        content: {
          title: "Total Lembaga",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menunjukan jumlah survey yang telah masuk",
          showInfo: true,
          showSaveAsImage: false,
          showTable: false,
          showDownloadTable: false,
        },
        options: {
          style: {
            height: "100%",
            contentFontSize: 90,
          },
        },
        state: {},
      },
    },
    chart: {
      jumlahResponden: {
        queryName: "jumlah_responden_per_agama",
        content: {
          title: "Jumlah Lembaga per Agama",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan grafik jumlah lembaga",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          chartOption: {
            tooltip: {
              trigger: "item",
            },
            series: [
              {
                name: "Jumlah Lembaga",
                type: "pie",
                label: {
                  formatter: "{b} ({d}%)",
                },
                radius: "75%",
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
                itemStyle: {
                  normal: {
                    color: (params) => {
                      const colorList = [
                        "#0C467B",
                        "#1879D3",
                        "#0085FF",
                        "#389BF6",
                        "#8EC9FF",
                      ];
                      return colorList[params.dataIndex];
                    },
                  },
                },
              },
            ],
          },
          columns: [
            {
              title: "Agama",
              dataIndex: "lembaga_jenispendidikan",
            },
            {
              title: "Jumlah Lembaga",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      trenPengisian: {
        queryName: "tren_pengisian_survey",
        content: {
          title: "Tren Pengisian Survey",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan grafik tren pengisian survey",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          chartOption: {
            grid: {
              top: 20,
              bottom: 20,
              left: 40,
              right: 20,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
            },
            legend: {
              data: ["Khonghucu", "Hindu", "Buddha", "Kristen", "Katolik"],
            },
            xAxis: {
              type: "category",
              data: [],
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                name: "Khonghucu",
                type: "line",
              },
              {
                name: "Hindu",
                type: "line",
              },
              {
                name: "Buddha",
                type: "line",
              },
              {
                name: "Kristen",
                type: "line",
              },
              {
                name: "Katolik",
                type: "line",
              },
            ],
          },
          columns: [
            {
              title: "Tanggal",
              dataIndex: "tanggal",
            },
            {
              title: "Jumlah Lembaga Agama Konghucu",
              dataIndex: "konghucu",
            },
            {
              title: "Jumlah Lembaga Agama Hindu",
              dataIndex: "hindu",
            },
            {
              title: "Jumlah Lembaga Agama Buddha",
              dataIndex: "buddha",
            },
            {
              title: "Jumlah Lembaga Agama Kristen",
              dataIndex: "kristen",
            },
            {
              title: "Jumlah Lembaga Agama Katolik",
              dataIndex: "katolik",
            },
          ],
          dataSource: [],
        },
        state: {
          data: [],
        },
      },
    },
  },
};
